import { colors } from "@indeed/ifl-tokens";
import React from "react";
import { StyleSheet } from "react-native";

import { Box } from "../../../../../../mads";
import { Text } from "../../../../../../mads/Text";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";
import { ScreenDisplay } from "../../../../context/ViewJobScreenDisplay";
import { OGWrappedCompanyInfoWithLogo } from "../CompanyInfoWithLogo/CompanyInfoWithLogo";
import { JobExpiredHeader } from "../JobExpiredHeader";
import { SalaryInfoAndJobType } from "../SalaryInfoAndJobType/SalaryInfoAndJobType";
import { TagContainer } from "../TagContainer";

interface TagModel {
  text: string;
}

interface JobInfoHeaderProps {
  isExpired?: boolean;
  employerActivity?: string;
  tags?: TagModel[];
}

export function JobInfoHeader({ isExpired = false, employerActivity, tags }: JobInfoHeaderProps) {
  return (
    <>
      {isExpired && <JobExpiredHeader />}

      <OGWrappedCompanyInfoWithLogo />
      <Box data-testid="jobsearch-OtherJobDetailsContainer">
        <ScreenDisplay.DesktopOnly>
          <SalaryInfoAndJobType />
        </ScreenDisplay.DesktopOnly>
        {employerActivity && (
          <Box sx={styles.employerActivity}>
            <Text sx={{ color: colors.neutral[700] }}>{employerActivity}</Text>
          </Box>
        )}
        {tags != null && tags.length > 0 && <TagContainer tags={tags} />}
      </Box>
    </>
  );
}

export const OGWrappedJobInfoHeader = () => {
  const viewjobOneGraphModel = useViewjobOneGraphModel();

  if (!viewjobOneGraphModel) {
    return null;
  }

  const { job } = viewjobOneGraphModel;
  const { isExpired, employerActivity, tags } = job;

  return <JobInfoHeader isExpired={isExpired} employerActivity={employerActivity} tags={tags} />;
};

const styles = StyleSheet.create({
  employerActivity: {
    marginTop: 8,
    marginBottom: 8,
    marginLeft: 16,
    paddingRight: 16,
  },
});
